<div class="action-view-overview-controls">
    <div class="d-flex gap-4" style="justify-content: center">
        <div class="d-flex gap-2" style="align-items: center">
            <label for="overview-organize-by-select" style="margin: 0">Organize By: </label>
            <select
                id="overview-organize-by-select"
                class="form-select form-select-sm d-inline-block"
                style="width: 150px"
                [disabled]="loading"
                [ngModel]="criteria.organizeBy"
                (ngModelChange)="setOrganizeBy($event)"
            >
                @for (item of organizeByItems; track item.id) {
                    <option [ngValue]="item.id">{{ item.name }}</option>
                }
            </select>
        </div>
        <div class="d-flex gap-2" style="align-items: center">
            <label for="overview-group-by-select" style="margin: 0">Group By: </label>
            <select
                id="overview-group-by-select"
                class="form-select form-select-sm d-inline-block"
                style="width: 180px"
                [disabled]="loading"
                [ngModel]="selectedGroupBy"
                (ngModelChange)="setGroupBy($event)"
            >
                <option [ngValue]="null">No Grouping</option>
                @for (group of groupByOptions; track group.id) {
                    <option [ngValue]="group.id">{{ group.name }}</option>
                }
            </select>
        </div>
    </div>
    <div class="mx-auto" style="width: 400px; margin-top: 20px">
        <div class="checkbox text-start">
            <label>
                <input
                    type="checkbox"
                    [ngModel]="criteria.showMostPressingTasks"
                    (ngModelChange)="setBoolean('showMostPressingTasks', $event)"
                />
                Summarize by category
                @if (criteria.thatAreChoice !== thatAre.Ready && criteria.thatAreChoice !== thatAre.Completed) {
                    <span>(includes only the most pressing tasks)</span>
                }
            </label>
        </div>
        @if (criteria.thatAreChoice === thatAre.ReadyOrNotReady) {
            <div class="checkbox text-start">
                <label>
                    <input
                        type="checkbox"
                        [ngModel]="criteria.calculateReadyAndNotReady"
                        (ngModelChange)="setBoolean('calculateReadyAndNotReady', $event)"
                    />
                    Display overview in Ready (Not Ready) format
                </label>
            </div>
        }
        <div class="checkbox text-start">
            <label>
                <input
                    type="checkbox"
                    [ngModel]="criteria.showTotals"
                    (ngModelChange)="setBoolean('showTotals', $event)"
                />
                Show Totals
            </label>
        </div>
    </div>
</div>
